var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGreenCheckCircle = function SvgGreenCheckCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#greenCheckCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#017A39",
    d: "M10 1.848A8.155 8.155 0 0 0 1.848 10c0 4.5 3.652 8.152 8.152 8.152S18.152 14.5 18.152 10 14.5 1.848 10 1.848m-.337 11.054a1.25 1.25 0 0 1-.924.402c-.348 0-.674-.141-.913-.391l-1.957-2.141 1.207-1.098L8.739 11.5l4.174-4.533 1.195 1.109-4.456 4.837z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "greenCheckCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.25 1.25h17.5v17.5H1.25z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCheckCircle);
export default ForwardRef;